<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.7368 3.39999H2.63135C1.37528 3.39999 0.37948 4.40711 0.37948 5.66318L0.368164 19.2423C0.368164 20.4983 1.37528 21.5055 2.63135 21.5055H20.7368C21.9929 21.5055 23 20.4983 23 19.2423V5.66318C23 4.40711 21.9929 3.39999 20.7368 3.39999ZM20.7368 19.2423H2.63135V12.4527H20.7368V19.2423ZM20.7368 7.92636H2.63135V5.66318H20.7368V7.92636Z"
      fill="currentColor"
    />
  </svg>
</template>
